import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { getApiData } from '../apiFunctions/getApiData';
import { LoadingSpinner } from './generic/LoadingSpinner';
import { ErrorAlert } from './generic/ErrorAlert';
import { ActivationKey } from '../types/ActivationKey';
import * as Constants from '../constants';

interface EnterActivationKeyProps {
    setStage: (stage: "EnterActivationKey" | "SelectUnits" | "Licenses") => void,
    activationKeyCode: string,
    setActivationKeyCode: (activationKeyCode: string) => void,
    setActivationKey: (activationKey: ActivationKey) => void
}

export const EnterActivationKey: React.FC<EnterActivationKeyProps> = props => {
    const { setStage, activationKeyCode, setActivationKeyCode, setActivationKey } = props;
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const setData = (activationKey: ActivationKey) => {
        setActivationKey(activationKey);

        if (activationKey.balance > 0)
            setStage("SelectUnits");
        else
            setErrorMessage("This activation key has no more license activations left.")
    }

    const loadApiData = () => {
        setErrorMessage("");
        getApiData(Constants.API_ACTIVATION_KEY_URL + "/" + encodeURIComponent(activationKeyCode), setLoading, setData, setErrorMessage);
    }

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.charCode === 13) {
            event.preventDefault();
            loadApiData();
        }
    }

    return <React.Fragment>
        {loading && <LoadingSpinner />}
        {!loading && errorMessage !== "" && <ErrorAlert errorMessage={errorMessage} />}
        {!loading && <Form>
            <Form.Group className="mb-3" controlId="activationKey">
                <Form.Label>Activation key</Form.Label>
                <Form.Control type="text" placeholder="EXA#-1MPLE-5KEY"
                    defaultValue={activationKeyCode}
                    onChange={(e: any) => {
                        setActivationKeyCode(e.currentTarget.value);
                    }}
                    onKeyPress={handleKeyPress}
                />
                <Form.Text className="text-muted">
                    You find the activation key on your activation key certificate.
                </Form.Text>
            </Form.Group>

            <Button className="button" disabled={activationKeyCode.length !== 15 && activationKeyCode.length !== 17} onClick={() => { loadApiData(); }}>
                Next
            </Button>
        </Form>}
    </React.Fragment>;
}